import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation UpdateMultiplierType($companyId: ID!, $id: ID!, $attributes: MultiplierTypeAttributes!) {
    updateMultiplierType(companyId: $companyId, id: $id, attributes: $attributes) {
      multiplierType {
        id
        ...UpdatedMultiplierType
      }
      errors {
        path
        message
      }
    }
  }

  fragment UpdatedMultiplierType on MultiplierType {
    id
    name
    multiplier
    multiplierType
    operandQuantity
    operandType
  }
`
